var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 8,
    viewBox: "0 0 13 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.84288 7.16667L0.509541 2.83333C-0.0182363 2.30556 -0.136014 1.70167 0.156208 1.02167C0.447319 0.340555 0.967875 0 1.71788 0H10.3012C11.0512 0 11.5718 0.340555 11.8629 1.02167C12.1551 1.70167 12.0373 2.30556 11.5095 2.83333L7.17621 7.16667C7.00954 7.33333 6.82899 7.45833 6.63454 7.54167C6.4401 7.625 6.23176 7.66667 6.00954 7.66667C5.78732 7.66667 5.57899 7.625 5.38454 7.54167C5.1901 7.45833 5.00954 7.33333 4.84288 7.16667Z",
    fill: "#003666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.650ffe66620cd34e1818cc3eaf7b824b.svg";
export { ForwardRef as ReactComponent };